
import { Component, Inject, inject, OnInit } from '@angular/core';
import { GenericStreamsService } from '../../../../../service/generic-streams.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { KeyQuestion, StreamClosingType } from '../../../../../lib/interfaces/generic-streams';
import { AppdataService } from '../../../../../service/appdata.service';
import { AgentConfig } from '../../../../../lib/interfaces/aitypes';

@Component({
    selector: 'app-edit-config',
    standalone: false,
    templateUrl: './edit-config.component.html',
    styleUrl: './edit-config.component.scss'
})
export class EditConfigComponent implements OnInit {
    streamService = inject(GenericStreamsService);
    dataService = inject(AppdataService);
    dialog = inject(MatDialogRef<EditConfigComponent>);
    fb = inject(FormBuilder);

    closingStreamTypes: StreamClosingType[] = [];
    editConfigForm: FormGroup = new FormGroup({});
    isLoading: boolean = false;
    agentList: AgentConfig[] = [];

    editKeyQuestionTitle: FormControl = new FormControl();
    editKeyQuestionQ: FormControl = new FormControl();
    keyQuestionDetailsEdit = "";

    editKeyQuestion = -1;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

    ngOnInit(): void {
        this.editConfigForm = this.fb.group({
            name: ['', Validators.required],
            description: ['', Validators.required],
            duration: [0],
            credits: [0],
            websearchStatus: [false],
            uploadStatus: [false],
            agentId: ['', Validators.required],
            agentPrompt: [''],
            closingPromptId: ['', Validators.required],
            keyQuestions: this.fb.array([]),
            requiredStepIds: this.fb.array([]),
            stepGoal: [null]
        });

        this.dataService.agents.asObservable().subscribe(agents => {
            this.agentList = agents;
        });


        this.streamService.getGenericConfigById(this.data.id).then((data: any) => {
            console.log("STREAM-CONFIG:", data);

            const keyQuestionsArray = this.fb.array(
                (data.keyQuestions || []).map((q: any) =>
                    this.fb.group({
                        title: [q.title || ''],
                        question: [q.question || ''],
                        description: [q.description || '']
                    })
                ),
            );

            const requiredStepIdsArray = this.fb.array(
                (data.requiredStepIds || []).map((id: any) => this.fb.control(id))
            );
            this.editConfigForm.patchValue({
                name: data.name || '',
                description: data.description || '',
                duration: data.duration || 0,
                credits: data.credits || 0,
                websearchStatus: data.websearchStatus || false,
                uploadStatus: data.uploadStatus || false,
                agentId: data.agentId || '',
                agentPrompt: data.agentPrompt || '',
                closingPromptId: data.closingPromptId || '',
                stepGoal: data.stepGoal || null
            });

            this.editConfigForm.setControl('keyQuestions', keyQuestionsArray);
            this.editConfigForm.setControl('requiredStepIds', requiredStepIdsArray);
        })

        this.closingStreamTypes = this.dataService.streamClosingTypes;
    }

    close() {
        this.dialog.close();
    }
    async update() {

        if (this.editConfigForm.valid === false) {
            return;
        }

        let result = await this.streamService.updateGenericStepConfig({ ...this.editConfigForm.value, id: this.data.id });
        if (result === false) return;

        console.log(this.editConfigForm.value)

        this.dialog.close();

    }
    get keyQuestions(): FormArray {
        return this.editConfigForm.get('keyQuestions') as FormArray;
    }
    addKeyQuestion(question: string, description: string, title: string) {
        const keyQuestionGroup = this.fb.group({
            title: [title, Validators.required],
            question: [question, Validators.required],
            description: [description, Validators.required]
        });
        (this.editConfigForm?.get('keyQuestions') as FormArray)?.push(keyQuestionGroup);
    }
    removeKeyQuestion(index: number) {
        (this.editConfigForm?.get('keyQuestions') as FormArray)?.removeAt(index);
    }

    changeQuestionOrder(previousIndex: number, currentIndex: number): void {
        const keyQuestions = this.editConfigForm?.get('keyQuestions') as FormArray;
        if (keyQuestions) {
            this.editKeyQuestion = -1;
            const question = keyQuestions.at(previousIndex);
            keyQuestions.removeAt(previousIndex);
            keyQuestions.insert(currentIndex, question);
        }
    }

    toggleKeyQuestionEdit(i: number) {
        if (this.editKeyQuestion !== i) {
            this.editKeyQuestion = i;
            this.editKeyQuestionTitle?.setValue(this.keyQuestions.controls[i].get('title')?.value);
            this.editKeyQuestionQ?.setValue(this.keyQuestions.controls[i].get('question')?.value);
        } else {
            this.editKeyQuestion = -1;
        }
    }
    saveKeyQuestionEdit(i: number) {

        (this.editConfigForm?.get('keyQuestions') as FormArray)?.controls[i].get('title')!.setValue(this.editKeyQuestionTitle.value);
        (this.editConfigForm?.get('keyQuestions') as FormArray)?.controls[i].get('question')!.setValue(this.editKeyQuestionQ.value);
        (this.editConfigForm?.get('keyQuestions') as FormArray)?.controls[i].get('description')!.setValue(this.keyQuestionDetailsEdit);
        this.toggleKeyQuestionEdit(i);

    }

    onKeyQuestionDetailsChange($event: any) {
        if (typeof $event == "string") {
            this.keyQuestionDetailsEdit = $event;
        }
    }

    get titleControl(): FormControl {
        return this.keyQuestions.controls[this.editKeyQuestion].get('title') as FormControl;
    }
    get questionControl(): FormControl {
        return this.keyQuestions.controls[this.editKeyQuestion].get('question') as FormControl;
    }
}
